import React from 'react'
import { Link } from 'react-router-dom'
import SearchUI from '../../../widgets/input/SearchUI'
import SelectUI from '../../../widgets/input/SelectUI'
import ButtonUI from '../../../widgets/action/ButtonUI'
import SpinnerUI from '../../../widgets/output/SpinnerUI'
import TabLinkUI from '../../../widgets/output/TabLinkUI'
import IconButtonUI from '../../../widgets/action/IconButtonUI'
import LRTableActionsUI from '../../../widgets/layout/LRTableActionsUI'
import './ClientTransactionHeader.css'

const ClientTransactionHeaderUI = ({context, account, bankAccountList, bankAccountNumber, txnList,
    searchFilter, onSearchFilterChange, onRefreshClick,
    financialYear, financialYearList, onFinancialYearChange,
  }) =>
  <div className='su_ctxn_hdr'>
    <BankAccountListUI
      context={context}
      account={account}
      bankAccountNumber={bankAccountNumber}
      bankAccountList={bankAccountList}
      onRefreshClick={onRefreshClick}
    />
    {
      txnList &&
      <LRTableActionsUI location='top'
        left={
          <ActionLeftUI
            context={context}
            txnList={txnList}
          />
        }
        right={
          <ActionTopRightUI
            context={context}
            financialYearList={financialYearList}
            financialYear={financialYear}
            onFinancialYearChange={onFinancialYearChange}
            searchFilter={searchFilter}
            onSearchFilterChange={onSearchFilterChange}
          />
        }
      />
    }
  </div>

  const BankAccountListUI = ({ context, account, bankAccountNumber, bankAccountList, onRefreshClick}) =>
    <div className='g_flex_h g_flex_top g_flex_left g_m_top_100'>
      {
        bankAccountList.map((bankAccount, i) =>
          <TabLinkUI label={bankAccount.bankAccountNumber} key={i}
            active={bankAccount.bankAccountNumber === bankAccountNumber}
            to={`/su/accounts/${account.accountId}/clienTxns/${bankAccount.bankAccountNumber}`}
          />
        )
      }
    </div>

  const ActionLeftUI = ({context, txnList}) =>
    <div className='g_flex_h'>
      {
        txnList.length > 0 &&
        <div className='g_muted'>
          <span className='g_m_left_50'>{txnList[0].bankFullName}</span>
          <span className='g_m_left_50'>IFSC: {txnList[0].ifscCode}</span>
          <span className='g_m_left_50'>Type: {txnList[0].accountType}</span>
        </div>
      }
    </div>

  const ActionTopRightUI = ({ context, financialYear, financialYearList, onFinancialYearChange, searchFilter, onSearchFilterChange}) =>
    <div className='g_flex_h'>
      <SelectUI selectedKey={'' + financialYear} optionList={financialYearList} onChange={onFinancialYearChange} placeholder='Year' />
      <div className='g_m_left_50' />
      <SearchUI value={searchFilter} onChange={onSearchFilterChange} />
    </div>

export default ClientTransactionHeaderUI
